module.exports = __webpack_public_path__ + "officialStatic/img/sw-detailList14.8edd9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw-detailList14.png
// module id = OmR1
// module chunks = 0